const { getOffsetTop, viewportSize } = window.BAO.Utils

class ParallaxFeature extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(this.onEntry.bind(this), {
      threshold: 0.3,
    })

    this.observer.observe(this)

    if (viewportSize() === 'xs' || !this.els?.item?.exists) return

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    if (viewportSize() === 'xs' || !this.els?.item?.exists) return

    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  onEntry ([entry], observer) {
    if (!entry.isIntersecting) return

    observer.unobserve(this)

    this.classList.add('sec-ParallaxFeature-active')
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.moveParallaxItem()
  }

  moveParallaxItem () {
    this.els.item.elements.forEach(itemEl => {
      if (itemEl.offsetParent === null) return

      const animationDuration = 10

      const windowHeight = window.innerHeight

      const amountToMoveY = parseFloat(itemEl.dataset.distanceY)
      const amountToMoveX = parseFloat(itemEl.dataset.distanceX)
      const elementHeight = itemEl.offsetHeight

      const actualItemHeight = elementHeight + amountToMoveY
      const heightDifference = actualItemHeight - elementHeight

      const elementStartPoint = getOffsetTop(itemEl) - windowHeight
      const elementEndPoint = getOffsetTop(itemEl) + elementHeight

      if (this.lastKnownY < elementStartPoint) {
        setTimeout(() => {
          itemEl.style.transform = `translate3d(${amountToMoveX}px, ${amountToMoveY /
            2}px, 0px)`
        }, animationDuration)

        return
      }

      if (this.lastKnownY > elementEndPoint) {
        setTimeout(() => {
          itemEl.style.transform = `translate3d(0px, ${amountToMoveY /
            -2}px, 0px)`
        }, animationDuration)

        return
      }

      const totalScrollAmount = elementEndPoint - elementStartPoint

      const scrollYAsAPercentageOfJourney =
        1 - (this.lastKnownY - elementStartPoint) / totalScrollAmount

      const transformAmountY =
        heightDifference * scrollYAsAPercentageOfJourney - heightDifference / 2

      const transformAmountX = amountToMoveX * scrollYAsAPercentageOfJourney

      setTimeout(() => {
        itemEl.style.transform = `translate3d(${transformAmountX}px, ${transformAmountY}px, 0px)`
      }, animationDuration)
    })
  }
}

if (!customElements.get('parallax-feature')) {
  customElements.define('parallax-feature', ParallaxFeature)
}
